import React from 'react';
import PropTypes from 'prop-types';
import './UnitSizeComparison.scss';
import { Image } from 'components/core/Image';

export function UnitSizeComparison({ icon, lazyLoad = true }) {
	return (
		<div className="vehicle-storage-unit">
			{icon && (
				<Image
					src={icon}
					alt="Vehicle Storage Icon"
					lazyLoad={lazyLoad}
				/>
			)}
		</div>
	);
}

UnitSizeComparison.propTypes = {
	icon: PropTypes.string,
	lazyLoad: PropTypes.bool,
};

export default UnitSizeComparison;
